import { AppProvider } from '@!/providers'
import Ranking from '@!/Store/Ranking/containers/Ranking'

const RankingApp = (props) => {
  return (
    <AppProvider>
      <Ranking tabName={props.tab_name} />
    </AppProvider>
  )
}

export default RankingApp
